import SlugInput from '../../../components/form-items/SlugInput';
import { Alert, Card, Form, Input, Select } from 'antd';
import { CreateLayout } from '../../../components/layout/layout/CreateLayout';
import { EcommerceIconComponent } from 'assets/icons/ecommerce';
import { IProduct, ProductableType } from 'interfaces/products';
import { KeyboardEvent, useCallback, useEffect, useState } from 'react';
import { PRODUCTABLE_TYPES } from 'constants/admin/products';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { slugify } from '../../../utils/slugify';
import { useForm } from '@refinedev/antd';
import { useLocation } from 'react-router-dom';
import { useProductableSelect } from 'hooks/useProductableSelect';

export const ProductCreate = () => {
  const location = useLocation();

  const [productType, setProductType] = useState<ProductableType>(
    PRODUCTABLE_TYPES[0].value
  );

  const { form, formProps, saveButtonProps } = useForm<IProduct>({
    redirect: 'edit'
  });

  useEffect(() => {
    if (location.state && location.state.productData) {
      form.setFieldsValue(location.state.productData);
    }
  }, [location.state, form]);

  const changeProductType = (value: ProductableType) => {
    setProductType(value);
    form.setFieldsValue({ productable_id: null });
  };

  const { selectProps: courseSelectProps } = useProductableSelect({
    resource: 'courses',
    onlyWithoutProduct: true
  });

  const { selectProps: graduateCourseSelectProps } = useProductableSelect({
    resource: 'graduate_courses',
    onlyWithoutProduct: true
  });

  const { selectProps: setSelectProps } = useProductableSelect({
    resource: 'products/sets',
    onlyWithoutProduct: true
  });

  const { selectProps: bundleSelectProps } = useProductableSelect({
    resource: 'products/bundles',
    onlyWithoutProduct: true
  });

  const { selectProps: externalItemSelectProps } = useProductableSelect({
    resource: 'external_items',
    onlyWithoutProduct: true
  });

  const createSlug = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      const value: string = (event.target as HTMLInputElement).value;

      form.setFieldsValue({ slug: slugify(value) });
    },
    [form]
  );

  const selectProps = (() => {
    switch (productType) {
      case 'Course': {
        return courseSelectProps;
      }

      case 'Graduate::Course': {
        return graduateCourseSelectProps;
      }

      case 'Products::Set': {
        return setSelectProps;
      }

      case 'Products::Bundle': {
        return bundleSelectProps;
      }

      case 'ExternalItem': {
        return externalItemSelectProps;
      }
    }
  })();

  return (
    <CreateLayout saveButtonProps={saveButtonProps}>
      <PageHeader title="Criar Produto" icon={EcommerceIconComponent} />
      <Card>
        <Alert
          message="Cada curso, pós, combo, set ou item externo só pode ser associado a um produto. Caso contrário, a criação não será efetuada"
          showIcon
          type="warning"
          style={{ marginBottom: '14px' }}
        />
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Tipo de produto"
            name="productable_type"
            initialValue={productType}
            className="max-w-xs"
          >
            <Select onChange={changeProductType}>
              {PRODUCTABLE_TYPES.map(type => (
                <Select.Option key={type.value}>{type.label}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input onKeyUp={createSlug} />
          </Form.Item>

          <SlugInput />

          <Form.Item
            label="Produto"
            name="productable_id"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select {...selectProps} />
          </Form.Item>
        </Form>
      </Card>
    </CreateLayout>
  );
};
